exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ntd[data-v-5682e79a]{\n    padding: 5px;\n    font-size: 12px;\n}\n", ""]);

// exports
